import {css} from "@panda/css";

import {ColumnList} from "../../atoms/ColumnList";
import {ColumnListItem} from "../../atoms/ColumnListItem";
import {IOfferArticle} from "../../offer/list/actions/fetch_offer_list_articles";
import {ArticleBox} from "./ArticleBox";

interface IProps {
    articles: IOfferArticle[];
    omitXlSize?: boolean;
}

export const HorizontalArticleList = (props: IProps) => {
    const {articles} = props;
    return (
        <ColumnList fluid rowClassName={rowClassName}>
            {articles.map((article) => {
                if (article.author == null) {
                    return null;
                }

                return (
                    <ColumnListItem key={article.id}>
                        <ArticleBox article={article} />
                    </ColumnListItem>
                );
            })}
        </ColumnList>
    );
};

const rowClassName = css({
    rowGap: "2.4rem !important" // important to override the default row gap
});
import {css} from "@panda/css";

import {ColumnList} from "../../atoms/ColumnList";
import {ColumnListItem} from "../../atoms/ColumnListItem";
import {IOfferArticle} from "../../offer/list/actions/fetch_offer_list_articles";
import {ArticleBox} from "./ArticleBox";

interface IProps {
    articles: IOfferArticle[];
    omitXlSize?: boolean;
}

export const HorizontalArticleList = (props: IProps) => {
    const {articles} = props;
    return (
        <ColumnList fluid rowClassName={rowClassName}>
            {articles.map((article) => {
                if (article.author == null) {
                    return null;
                }

                return (
                    <ColumnListItem key={article.id}>
                        <ArticleBox article={article} />
                    </ColumnListItem>
                );
            })}
        </ColumnList>
    );
};

const rowClassName = css({
    rowGap: "2.4rem !important" // important to override the default row gap
});
